module.exports = __webpack_public_path__ + "static/img/ajizufoto.a67dca7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/miembros/ajizufoto.png
// module id = 2m5S
// module chunks = 0